import { Component, OnInit } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
    selector: 'app-skeleton-dqf-review',
    templateUrl: './skeleton-dqf-review.component.html',
    styleUrls: ['../dqf-review.component.scss', './skeleton-dqf-review.component.scss'],
    standalone: true,
    imports: [NgxSkeletonLoaderModule]
})
export class SkeletonDqfReviewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
